<form [formGroup]="learnMoreForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6 p-6">
  <!-- Cover Image Field -->
  <div class="flex flex-col gap-2">
    <label class="font-medium">{{ 'learnMore.coverImage' | translate }}</label>
    
    @if (previewImageUrl) {
      <div class="relative inline-block">
        <img 
          [src]="previewImageUrl" 
          [alt]="'learnMore.imagePreview' | translate"
          class="w-full max-w-sm h-48 object-cover rounded border border-gray-600"
        />
        <p-button
          type="button"
          icon="pi pi-times"
          [rounded]="true"
          size="small"
          (onClick)="removeImage()"
          class="absolute top-2 right-2"
          [ariaLabel]="'learnMore.removeImage' | translate"
        >
        </p-button>
      </div>
    } @else {
      <p-fileUpload
        mode="basic"
        [chooseLabel]="'learnMore.chooseImage' | translate"
        accept="image/*"
        [maxFileSize]="10000000"
        [auto]="true"
        (onSelect)="onImageSelect($event)"
        class="w-full"
      ></p-fileUpload>
    }
  </div>

  <!-- Title Field -->
  <div class="flex flex-col gap-2">
    <label for="title" class="font-medium">{{ 'learnMore.itemTitle' | translate }}</label>
    <input
      id="title"
      type="text"
      pInputText
      [formControl]="titleControl"
      [placeholder]="'learnMore.titlePlaceholder' | translate"
      class="w-full"
    />
    @if (titleControl.invalid && titleControl.touched) {
    <p-message severity="error">
      {{ getTitleErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Description Field -->
  <div class="flex flex-col gap-2">
    <label for="description" class="font-medium">{{ 'learnMore.description' | translate }}</label>
    <textarea
      id="description"
      [formControl]="descriptionControl"
      [placeholder]="'learnMore.descriptionPlaceholder' | translate"
      rows="4"
      class="w-full p-3 border border-gray-600 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-700 text-white"
    ></textarea>
    @if (descriptionControl.invalid && descriptionControl.touched) {
    <p-message severity="error">
      {{ getDescriptionErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Link URL Field -->
  <div class="flex flex-col gap-2">
    <label for="linkUrl" class="font-medium">{{ 'learnMore.linkUrl' | translate }}</label>
    <input
      id="linkUrl"
      type="url"
      pInputText
      [formControl]="linkUrlControl"
      [placeholder]="'learnMore.linkUrlPlaceholder' | translate"
      class="w-full"
    />
    @if (linkUrlControl.invalid && linkUrlControl.touched) {
    <p-message severity="error">
      {{ getLinkUrlErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Action Buttons -->
  <div class="flex flex-row gap-4 mt-6">
    <p-button
      type="submit"
      [label]="submitting() 
        ? (isEdit ? ('learnMore.updating' | translate) : ('learnMore.adding' | translate))
        : (isEdit ? ('learnMore.updateItem' | translate) : ('learnMore.addItem' | translate))"
      [icon]="submitting() ? 'pi pi-spin pi-spinner' : (isEdit ? 'pi pi-save' : 'pi pi-plus')"
      [disabled]="learnMoreForm.invalid || submitting()"
      [loading]="submitting()"
    />

    <p-button
      type="button"
      [label]="'learnMore.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      [disabled]="submitting()"
      (onClick)="onCancel()"
    />
  </div>
</form>